import { Article } from '../types/Article';
import { useAsync } from 'react-async-hook';
import { Category } from '../types/Category';
import { wordpress } from '../client';

export const useArticles = () => {
  const { result: categories, loading } = useAsync(fetchCategories, []);
  const { result: articles, loading: loading1 } = useAsync(
    () => fetcherPosts(categories ?? []),
    [categories],
  );
  return { articles, loading: loading || loading1 };
};

const fetchCategories = () =>
  wordpress.categories().orderby('id').order('asc') as unknown as Promise<Category[]>;

const fetcherPosts = async (categories: Category[]) => {
  const promises = categories?.map((category) =>
    fetchPosts(category.id).then((articles) => ({
      category,
      articles,
    })),
  );
  return Promise.all(promises).then((postsForCategories) =>
    postsForCategories.filter(({ articles }) => articles.length > 0),
  );
};

const fetchPosts = (categoryId: number) =>
  wordpress.posts().categories(categoryId).perPage(10).orderby('date').order('desc') as Promise<
    Article[]
  >;
